import { ReactNode } from "react";

import { ErrorBoundary } from "./ErrorBoundary";

type Params = {
  fallback: ReactNode;
};

export const WithErrorBoundary = (
  children: ReactNode,
  { fallback }: Params,
) => {
  const ErrBoundary = () => {
    return <ErrorBoundary fallback={fallback}>{children}</ErrorBoundary>;
  };

  return ErrBoundary;
};
